/**
 * Turn `\[` and `\]` back into literal brackets where they are punctuation.
 *
 * MathJax is configured with `displayMath: [['$$','$$'], ['\\[','\\]']]`, so a
 * UCAT explanation reading `Amounts \[of porcelain\] increased` has the
 * bracketed words pulled out as a centred display equation. The author meant
 * square brackets around an editorial insertion.
 *
 * A `\[` preceded by another backslash is left alone. That is LaTeX's row
 * spacing command, as in `\\[6pt]` inside a TMUA `$$...$$` block, and rewriting
 * it would break the matrix it lays out.
 */
export function unescapeLiteralSquareBrackets(text) {
  if (typeof text !== 'string' || !text.includes('\\')) return text || '';
  return text
    .replace(/(?<!\\)\\\[/g, '[')
    .replace(/(?<!\\)\\\]/g, ']');
}
